export default __webpack_public_path__ + "static/media/white-bg-incorrect2.a59f3d7d.PNG";